import config from 'config/default'

const { baseUrl } = config

/**
 * 获取某一课程主题的信息
 * @param name
 */
export const getTheme = async theme => {
    const url = `${baseUrl}/data/themes/${theme}.json`
    return await fetch(url)
        .then(resp => resp.json())
        .catch(() => null)
}